var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStopIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.b{fill:none;}.b{stroke:currentColor;stroke-miterlimit:10;stroke-width:1.5px;}.c{fill:currentColor;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-558 -4391)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 18,
    height: 18,
    transform: "translate(558 4391)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(495 4328)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M80,72a8,8,0,1,0-8,8A8,8,0,0,0,80,72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M181.6,182.667h-4.533A1.068,1.068,0,0,1,176,181.6v-4.533A1.068,1.068,0,0,1,177.067,176H181.6a1.068,1.068,0,0,1,1.067,1.067V181.6A1.068,1.068,0,0,1,181.6,182.667Z",
    transform: "translate(-107.333 -107.333)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStopIcon);
export default __webpack_public_path__ + "static/media/stop-icon.b8bd0ddc1b2045c9bf8b5b50dc51322a.svg";
export { ForwardRef as ReactComponent };